import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-quill/dist/quill.snow.css';
import 'jsvectormap/dist/css/jsvectormap.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfirmProvider } from './context/BootstrapConfirm';
import { NotificationProvider } from './context/BootstrapToast';
import { ToastContainer } from 'react-toastify';
// import { CookiesProvider } from 'react-cookie';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/">
            <AuthProvider>
                <NotificationProvider>
                    <ConfirmProvider>
                        <App />
                        <ToastContainer autoClose={3000} closeButton position="top-right" limit={5} pauseOnHover />
                    </ConfirmProvider>
                </NotificationProvider>
            </AuthProvider>
    </BrowserRouter>,
);

reportWebVitals();
